import { Link } from 'react-router-dom'

import { css, styled } from '@styles/theme'

export const NotebooksStyles = {
	container: css({
		background: '$neutral30',
		width: '100%',
		padding: '24px',

		'@sm': {
			padding: '8px 65px 8px 61px',
		},
	}),
	titleIndex: css({
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'column',
		marginBottom: '16px',

		'@sm': {
			marginTop: '40px',
			marginBottom: '32px',
		},

		'div.contentTop': {
			display: 'flex',
			gap: '16px',
			marginTop: '16px',
			alignItems: 'flex-end',
			flexDirection: 'column-reverse',
		},

		'@md': {
			flexDirection: 'row',

			'div.contentTop': {
				display: 'flex',
				gap: '28px',
				marginTop: '0px',
				flexDirection: 'row',
			},
		},
	}),
	title: css({
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'column',
		marginTop: '19px',
		marginBottom: '32px',

		div: {
			display: 'flex',
			gap: '5px',
			marginTop: '10px',
			flexDirection: 'column-reverse',
		},

		'@md': {
			flexDirection: 'row',

			div: {
				display: 'flex',
				gap: '28px',
				marginTop: '0px',
				flexDirection: 'row',
			},
		},
	}),

	containerFolder: css({
		display: 'grid',
		gridTemplateColumns: '1fr',
		flexDirection: 'column',
		gap: '24px',
		rowGap: '18px',
		marginTop: '24px',
		marginBottom: '24px',

		'@md': {
			gridTemplateColumns: 'repeat(4, minmax(287px, 100%))',
			flexDirection: 'row',
			gap: '35px',
			marginBottom: '29px',
		},
	}),

	folderCard: css({
		display: 'flex',
		justifyContent: 'space-between',
		width: '100%',
		minHeight: '78px',
		padding: '16px',
		background: '$neutral10',
		borderRadius: '12px',
		border: '1px solid $neutral50',

		'&:hover': {
			borderColor: '$blue20',

			a: {
				div: {
					svg: {
						color: '$blue20',
					},
					p: {
						color: '$blue20',
					},
					div: {
						p: {
							color: '$blue20',
						},
					},
				},
			},

			button: {
				div: {
					svg: {
						color: '$blue20',
					},
					p: {
						color: '$blue20',
					},
					div: {
						p: {
							color: '$blue20',
						},
					},
				},
			},
		},
	}),

	iconDesc: css({
		display: 'flex',
		gap: '8px',
		cursor: 'pointer',
	}),

	iconFolder: css({
		svg: {
			width: '25px',
			height: '25px',
			color: '$neutral100',
		},
	}),

	containerTitleFolder: css({
		display: 'inline-grid',
		gap: '6px',

		p: {
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
		},
	}),

	containerNotebooks: css({
		display: 'flex',
		flexDirection: 'column',
		gap: '8px',
		marginTop: '24px',
	}),

	buttonDropdown: css({
		display: 'flex',
		justifyContent: 'flex-end',
		width: '100%',
		color: '$neutral160',
		cursor: 'pointer',

		svg: {
			width: '25px',
			height: '25px',
		},
	}),

	dropdownItems: css({
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		minWidth: '200px',
		maxWidth: '200px',
		background: '$neutral10',
		boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
		borderRadius: '12px',
		position: 'absolute',
		transform: 'translateX(-166px)',
	}),

	dropdownItemsCreate: css({
		display: 'flex',
		flexDirection: 'column !important',
		width: '100%',
		minWidth: '200px',
		maxWidth: '100%',
		background: '$neutral10',
		boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
		borderRadius: '12px',
		position: 'absolute',
		transform: 'translateX(-28px) translateY(123px)',
		gap: '0px !important',

		'@md': {
			padding: '0px',
			transform: 'translateX(-28px) translateY(48px)',
			maxWidth: '200px',
		},
	}),

	dropdownItemsCreateFilter: css({
		display: 'flex',
		flexDirection: 'column !important',
		width: '100%',
		minWidth: '200px',
		maxWidth: '100%',
		background: '$neutral10',
		boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
		borderRadius: '12px',
		position: 'absolute',
		transform: 'translateX(-28px) translateY(61px)',
		gap: '0px !important',

		'@md': {
			padding: '0px',
			transform: 'translateX(-28px) translateY(48px)',
			maxWidth: '200px',
		},
	}),

	dropdownItem: css({
		display: 'flex',
		width: '100%',
		minWidth: '200px',
		maxWidth: '200px',
		background: '$neutral10',
		padding: '20px',
		cursor: 'pointer',
		gap: '8px',
		color: '$neutral160',

		_font: 'normal',
		fontWeight: 400,
		fontSize: '$md',
		lineHeight: '21px',

		svg: {
			width: '20px',
			height: '20px',
		},

		'&:first-child': {
			borderBottomLeftRadius: '0px',
			borderBottomRightRadius: '0px',
			borderTopLeftRadius: '12px',
			borderTopRightRadius: '12px',
		},

		'&:nth-child': {
			borderBottomLeftRadius: '0px',
			borderBottomRightRadius: '0px',
			borderTopLeftRadius: '12px',
			borderTopRightRadius: '12px',
		},

		'&:last-child': {
			borderBottom: '0px',
			borderBottomLeftRadius: '12px',
			borderBottomRightRadius: '12px',
			borderTopLeftRadius: '0px',
			borderTopRightRadius: '0px',
		},
	}),

	LinkToQuestion: styled(Link, {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: '10px',
		marginBottom: '19.5px',

		_font: 'normal',
		fontWeight: '400',
		fontSize: '16px',
		lineHeight: '19px',
		letterSpacing: '0.05em',

		color: '$neutral130',

		cursor: 'pointer',
	}),
}
